import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setModal, selectModal } from '../../../redux/modalSlice'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'

export default function UnholdPaymentsModal() {
  const dispatch = useDispatch()
  const modal = useSelector(selectModal)

  const [saving, setSaving] = useState(false)
  const request = useRequest()
  const loanId = modal.options?.loanId
  const currentDate = modal.options?.currentDate;

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }))
  }

  const handleSubmit = async () => {
    setSaving(true)
    request.setEndpoint(
      `${process.env.REACT_APP_API_DOMAIN}/loan/${loanId}/unhold_payments`
    )
    try {
      const response = await request.modify({ current_date: currentDate })
      if (response.status === 200) {
        setSaving(false)
        dispatch(setModal({ is_active: false }))
        modal.options.successCallback();
        dispatch(setNotification({ type: 'success', body: '' }))
      } else {
        setSaving(false)
        dispatch(
          setNotification({ type: 'error', body: `Error: ${response.status}` })
        )
      }
    } catch (error) {
      setSaving(false)
      const errorMessage =
        error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  return modal.is_active && modal.type === 'unhold_payments_modal' ? (
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card modal-card-confirmation column is-7">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              {'Unhold Payments'}
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-1 pb-1"
            style={{ minHeight: '30px', overflow: 'hidden' }}
          >
            <div className="columns mb-0 is-flex-direction-column">
              <div className="column">
                <h3>
                  Are you sure you want to unhold all payments?
                </h3>
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button
                type="submit"
                className="button is-small is-link mx-1"
                onClick={() => handleSubmit()}
                disabled={saving}
              >Yes
              </button>
              <button
                type="button"
                className="button is-small has-background-grey has-text-white mx-1"
                onClick={handleCancel}
              >No
              </button>
            </div>
          </footer>
        </div>
      </div>

  ) : null
}
